import React, { FC } from 'react';
import styles from '../LandingPageStep.scss';
import clsx from 'clsx';
import LpAsset4 from 'assets/svgs/lp-asset-4.svg';
import LpAsset1 from 'assets/svgs/lp-asset-1.svg';
import LpAsset2 from 'assets/svgs/lp-asset-2.svg';

export const LandingPageStepContentAssetsMobile: FC = () => {
  return (
    <div className={styles.landingPageStepAssets}>
      <div>
        <div className={clsx(styles.landingPageStepAssetsImage, styles.hat)}>
          <img
            src="https://static.wixstatic.com/media/0784b1_685003a405b74e01ba74431e99cbf322~mv2.jpg/v1/fill/w_136,h_164,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Group%204721799%20copy.jpg"
            alt="Landing Page Step Asset"
          />
          <div className={styles.asset4}>
            <LpAsset4 />
          </div>
        </div>
        <div className={styles.asset1}>
          <LpAsset1 />
          <div className={styles.asset2}>
            <LpAsset2 />
          </div>
        </div>
      </div>
      <div>
        <div className={styles.knobs}>
          <div />
          <div />
          <div />
        </div>
        <div className={styles.landingPageStepAssetsImage}>
          <img
            src="https://static.wixstatic.com/media/058543_b135378ede4f451e82432afcf4462ddd~mv2.jpg/v1/fill/w_172,h_372,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Group%204721802%20copy.jpg"
            alt="Landing Page Step Asset"
          />
        </div>
      </div>
    </div>
  );
};
